import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useObjectData(id) {
  const store = useStore();
  const storages = computed(() => store.state.admin.objectDetails[id]?.storages);
  const contractors = computed(() => store.state.admin.objectDetails[id]?.contractors);
  return { storages, contractors };
}
